export type DialogPlacement =
	| 'top left'
	| 'top center'
	| 'top right'
	| 'right top'
	| 'right middle'
	| 'right bottom'
	| 'bottom left'
	| 'bottom center'
	| 'bottom right'
	| 'left top'
	| 'left middle'
	| 'left bottom';

export const HEADER_DROPDOWN_X2C_NUDGE_STEP = 'HEADER_DROPDOWN_X2C_NUDGE_STEP';
export const HEADER_X2C_NUDGE_STEP = 'HEADER_X2C_NUDGE_STEP';

export const APP_IDENTIFIER = 'jira-business.project-create-importer-onboarding';

export const ERROR_BOUNDARY_ID_X2C_TOUR_NUDGE = 'asyncJWMX2CTourNudge';

export const DEFAULT_NUDGE_WIDTH = 275;
export const BOTTOM_LEFT: DialogPlacement = 'bottom left';
export const RIGHT_TOP: DialogPlacement = 'right top';
